import { colors } from '@dexma/ui-components';
import { A4_PADDING_X, A4_PADDING_Y } from 'adapter/in/dashboards/components/Grid/constants';
import styled from 'styled-components';

type StyledGridSizeProps = { $editLayoutWidthStyle: string; $backgroundColor: string; $marginY?: number; $isLayoutEmpty?: boolean };

const StyledGridSize = styled.div<StyledGridSizeProps>`
    position: relative;
    padding: ${A4_PADDING_Y}px ${A4_PADDING_X}px;
    height: 100%;
    overflow-y: ${({ $isLayoutEmpty }) => ($isLayoutEmpty ? 'invisible' : 'scroll')};
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    margin: auto;
    width: ${({ $editLayoutWidthStyle }) => $editLayoutWidthStyle};
    box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px,
        rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px;

    .page-break-overlay {
        pointer-events: none;
        position: absolute;
        top: ${({ $marginY }) => ($marginY ? `${A4_PADDING_Y - $marginY / 2}px` : `${A4_PADDING_Y}px`)};
        bottom: ${({ $marginY }) => ($marginY ? `${A4_PADDING_Y - $marginY / 2}px` : `${A4_PADDING_Y}px`)};
        left: 0;
        right: 0;
    }

    .page-break-line {
        position: absolute;
        left: 0;
        right: 0;
        border-top: 2px dashed ${colors.gray800};
        z-index: 9999;
    }

    @media print {
        .page-break-line {
            border-color: transparent;
        }
    }
`;

export default StyledGridSize;
